import request from '@/utils/request'
import { uuid } from 'vue-uuid';
import { obj2query } from '@/utils'
import { getToken } from '@/utils/auth'



export function getCustomerBy(uid){
  return request({
    url: "/api/v2/customers/" + uid,
    method: "get"
  });
}


export function updateCustomer(uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/v2/customers/" + uid,
    method: "put",
    data: data
  });
}
